import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const SpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height:  100%;
  z-index: 20;
`

export const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 10;
  border-radius: 6px;
`
export const SelectedActivityList = styled.ul`
  overflow: auto;
`
export const SelectedActivityListItem = styled.li`
  display: block;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  padding: 8px 8px 8px 50px;
  margin-bottom: 16px;
  cursor: pointer;
  color: #000;
`

export const SelectedActivityRemoveIcon = styled(FontAwesomeIcon)`
  position: absolute;
  left: 20px;
  top: 8px;
  text-align: center;
  color: red;
`

export const SelectedActivityListItemLabel = styled.div`
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
`

export const FrequencyDropDownLabel = styled.p`
  padding: 0.2em 0.5em 0.2em 0;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.5);
  background: #ffffff;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  margin-bottom: 0;
`

export const ActivityWrapper = styled.div`
  display: flex;
`
